exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[role=button],[role=tab],a,button{cursor:pointer}html[dir] input,html[dir] textarea{-webkit-box-shadow:none!important;box-shadow:none!important}@media (prefers-color-scheme:dark){.HyHr8V6cgd9\\+fa-RrAO6DQ\\=\\=:focus{outline:none}html[dir] .HyHr8V6cgd9\\+fa-RrAO6DQ\\=\\=:focus{-webkit-box-shadow:none;box-shadow:none;border:2px solid var(--dark-mode-border-color)}}", ""]);
// Exports
exports.locals = {
	"button": "HyHr8V6cgd9+fa-RrAO6DQ=="
};